/* ============================================================
   GEBERT & WESCHKA — Shopify Theme Scripts
   Scoped to .gw* elements. Safe to run on any page; every
   feature checks for its own elements before binding and is
   idempotent (won't double-bind on Shopify section reloads).
   ============================================================ */
(function () {
  'use strict';

  // Each GW section loads this script, so it may be included more than
  // once on a page. Run the one-time global setup only once; later
  // includes just re-scan the DOM (cheap & idempotent).
  if (window.GWTheme) {
    window.GWTheme.init(document);
    return;
  }

  // Signal to CSS that JS is active (enables scroll-reveal hiding).
  document.documentElement.classList.add('gw-js');

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- File upload dropzone (Sofortangebot) ---------- */
  function initDropzones(scope) {
    var zones = (scope || document).querySelectorAll('.gw-dropzone');
    zones.forEach(function (zone) {
      if (zone.dataset.gwBound) return;
      zone.dataset.gwBound = '1';

      var input = zone.querySelector('input[type=file]');
      var form = zone.closest ? zone.closest('form') : zone.parentNode;
      var host = form || zone.parentNode;
      var chosen = host.querySelector('.gw-file-chosen');
      var hidden = host.querySelector('[data-gw-filename]');
      if (!input) return;

      function showFile(name) {
        if (chosen) chosen.textContent = name ? '✓ ' + name : '';
        // Carry the filename into the contact email (file bytes are not
        // transmitted by Shopify's contact form — see gw-quote.liquid).
        if (hidden) hidden.value = name || '';
      }

      zone.addEventListener('click', function () { input.click(); });
      zone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
      });
      input.addEventListener('change', function () {
        if (input.files.length) showFile(input.files[0].name);
      });
      ['dragover', 'dragenter'].forEach(function (ev) {
        zone.addEventListener(ev, function (e) {
          e.preventDefault();
          zone.classList.add('gw-drag');
        });
      });
      ['dragleave', 'dragend'].forEach(function (ev) {
        zone.addEventListener(ev, function () { zone.classList.remove('gw-drag'); });
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('gw-drag');
        if (e.dataTransfer && e.dataTransfer.files.length) {
          try { input.files = e.dataTransfer.files; } catch (err) { /* some browsers */ }
          showFile(e.dataTransfer.files[0].name);
        }
      });
    });
  }

  /* ---------- Gentle submit state on GW forms ----------
     These are real Shopify contact forms (they POST & reload),
     so we DON'T preventDefault — we just give feedback while the
     browser submits. The success banner is rendered server-side
     via Liquid (form.posted_successfully?). */
  function initForms(scope) {
    var forms = (scope || document).querySelectorAll('form.gw-js-form');
    forms.forEach(function (form) {
      if (form.dataset.gwBound) return;
      form.dataset.gwBound = '1';
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type=submit]');
        if (btn && !btn.disabled) {
          btn.dataset.gwLabel = btn.innerHTML;
          btn.innerHTML = 'Wird gesendet …';
          btn.disabled = true;
          // Re-enable if the navigation is blocked (validation, etc.)
          setTimeout(function () {
            if (document.body.contains(btn)) {
              btn.disabled = false;
              if (btn.dataset.gwLabel) btn.innerHTML = btn.dataset.gwLabel;
            }
          }, 4000);
        }
      });
    });
  }

  /* ---------- Cursor spotlight on cards ---------- */
  function initSpotlight(scope) {
    if (reduceMotion) return;
    var cards = (scope || document).querySelectorAll('.gw-spot');
    cards.forEach(function (card) {
      if (card.dataset.gwSpot) return;
      card.dataset.gwSpot = '1';
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var io = null;
  function getObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('gw-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    return io;
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.gw-reveal');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gw-in'); });
      return;
    }
    var obs = getObserver();
    els.forEach(function (el) {
      if (el.dataset.gwReveal) return;
      el.dataset.gwReveal = '1';
      // subtle stagger within a group of siblings
      var sibs = el.parentNode ? el.parentNode.children : [el];
      var idx = Array.prototype.indexOf.call(sibs, el);
      el.style.transitionDelay = ((idx % 4) * 0.06) + 's';
      obs.observe(el);
    });
  }

  /* ---------- Product page: gallery, 3D toggle, variants ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var thumb = e.target.closest('.gw-pdp-thumb');
    if (thumb) {
      var pdp = thumb.closest('.gw-pdp'); if (!pdp) return;
      var main = pdp.querySelector('.gw-pdp-photo img');
      // srcset/sizes überstimmen .src → erst entfernen, sonst wechselt das Bild nicht
      if (main && thumb.dataset.full) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = thumb.dataset.full; }
      pdp.classList.remove('gw-show3d');
      pdp.querySelectorAll('.gw-pdp-thumb').forEach(function (t) { t.classList.remove('gw-active'); });
      thumb.classList.add('gw-active');
      // Lightbox soll beim gerade gezeigten Bild öffnen
      var ph = pdp.querySelector('.gw-pdp-photo');
      if (ph && thumb.dataset.index) ph.setAttribute('data-index', thumb.dataset.index);
      var pv = pdp.querySelector('.gw-pdp-view[data-view=photo]');
      if (pv) { pdp.querySelectorAll('.gw-pdp-view').forEach(function (v) { v.classList.remove('gw-active'); }); pv.classList.add('gw-active'); }
      return;
    }
    var lbOpen = e.target.closest('[data-gw-lb-open]');
    if (lbOpen && !lbOpen.closest('.gw-pdp.gw-show3d')) {
      if (window.GWLightbox) { window.GWLightbox.open(parseInt(lbOpen.getAttribute('data-index'), 10) || 0); return; }
    }
    var view = e.target.closest('.gw-pdp-view');
    if (view) {
      var pdp2 = view.closest('.gw-pdp'); if (!pdp2) return;
      pdp2.querySelectorAll('.gw-pdp-view').forEach(function (v) { v.classList.remove('gw-active'); });
      view.classList.add('gw-active');
      if (view.getAttribute('data-view') === '3d') {
        pdp2.classList.add('gw-show3d');
        if (window.GW3D) window.GW3D.scan(pdp2);
      } else { pdp2.classList.remove('gw-show3d'); }
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-gw-variant-select]');
    if (!sel) return;
    var pdp = sel.closest('.gw-pdp'); if (!pdp) return;
    var opt = sel.options[sel.selectedIndex];
    var price = opt.getAttribute('data-price');
    if (price) pdp.querySelectorAll('[data-gw-price]').forEach(function (el) { el.textContent = price; });
    // Nettozeile mitziehen. Der Wert kommt fertig gerechnet aus dem
    // data-netto der Option (Liquid, siehe gw-product-main), damit hier kein
    // zweiter Steuersatz gepflegt werden muss.
    var netto = opt.getAttribute('data-netto');
    if (netto) pdp.querySelectorAll('[data-gw-netto]').forEach(function (el) { el.textContent = netto; });
    var avail = opt.getAttribute('data-available') === 'true';
    pdp.querySelectorAll('[data-gw-atc]').forEach(function (btn) {
      btn.disabled = !avail;
      var lbl = btn.querySelector('[data-gw-atc-label]') || btn;
      lbl.textContent = avail ? (btn.getAttribute('data-label-add') || 'In den Warenkorb') : 'Ausverkauft';
    });
  });

  /* ---------- Product page: sticky add-to-cart bar ---------- */
  function initSticky(scope) {
    var root = scope || document;
    var bar = root.querySelector('[data-gw-stickybar]');
    var buy = root.querySelector('.gw-pdp-buy');
    if (!bar || !buy || bar.dataset.gwBound || !('IntersectionObserver' in window)) return;
    bar.dataset.gwBound = '1';
    new IntersectionObserver(function (es) {
      var en = es[0];
      bar.classList.toggle('gw-show', !en.isIntersecting && en.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buy);
  }

  /* ---------- Punktraster: einzelne Punkte blitzen auf ----------
     Vorgabe Henry 06.09.2026, Werte aus dem Pruefstand.

     Warum eine Leinwand und kein CSS: einzelne Punkte lassen sich mit einem
     wiederholten background-image nicht ansprechen. Eine Maske kann nur ganze
     Bereiche auf- und abblenden -- genau das war der Vorlaeufer, und er war
     nicht gemeint. Die Leinwand zeichnet nur die Punkte, die gerade brennen,
     an derselben Rasterstelle wie das ruhende Muster darunter.

     Der Anteil wird GEHALTEN, nicht angesteuert: fuer jeden erloschenen Punkt
     geht sofort ein anderer auf. Damit brennen immer gleich viele, nur die
     Stellen wechseln. */
  /* Werte aus dem Pruefstand, Vorgabe Henry 06.09.2026:
     Raster 25 px - Grundraster .10 - Blitz .35 - Streuung 0 - 1,0 s;
     Anteil je Kasten in GRUPPEN (CNC 2 %, Zuschnitt 4 %).
     raster und die Punktstaerke des ruhenden Musters stehen zusaetzlich im
     CSS (gw.css fuer .gw-quote, gw-cut.js fuer .gwc-sum) -- wer hier etwas
     aendert, muss dort nachziehen, sonst sitzen die Blitze neben den Punkten. */
  var FUNKEN = {
    raster: 25,   /* == background-size des Rasters in gw.css / gw-cut.js */
    anteil: 4,    /* Prozent aller Rasterpunkte, die gleichzeitig brennen  */
    hell:   0.35, /* Deckkraft im Hoehepunkt (1 = reines Weiss)            */
    streu:  0,    /* Radius des Hofs in px; 0 = harte Kante, kein Hof      */
    dauer:  1.0   /* Sekunden vom Aufgehen bis zum Verloeschen             */
  };

  /* Der Anteil haengt an der Flaechengroesse (Vorgabe Henry 06.09.2026):
     .gw-quote ist die volle Seitenbreite mit 106 px Innenabstand, dort sind
     4 % mehrere hundert Punkte gleichzeitig. Der Rechnerkasten ist ein
     Bruchteil davon und vertraegt denselben Anteil gut. */
  /* 26.09. auf 3 / 6 erhoeht, am 27.09. auf Henrys Wunsch noch einmal um die
     Haelfte: "mach die im Vergleich zu sich selbst 50 % mehr". */
  var GRUPPEN = [
    { wahl: '.gw-quote', anteil: 4.5 },  /* grosse CNC-Flaeche */
    { wahl: '.gwc-sum',  anteil: 9 }     /* Zuschnitt-Rechner  */
  ];

  /* Auf dem Telefon MEHR Prozent, nicht weniger.
     Der Anteil bezieht sich auf die Rasterpunkte der Flaeche -- und die
     schrumpfen quadratisch mit. Der Zuschnitt-Rechner ist am Rechner rund
     560 x 640 px gross, das sind 22 x 25 = 550 Rasterstellen; auf einem
     375-px-Telefon bleiben 13 x 25 = 325. Bei gleichem Prozentsatz brennen
     dort also fast nur halb so viele Punkte, und die Flaeche wirkt tot.
     Deshalb hebt ein schmaler Bildschirm den Anteil an.
     Vorgabe Henry 26.09.2026: mehr Punkte, vor allem auf dem Handy. */
  function anteil_fuer(grund) {
    var b = window.innerWidth || 1024;
    if (b < 500) return grund * 2.0;
    if (b < 800) return grund * 1.5;
    return grund;
  }

  /* Auf Windows-Rechnern mit abgeschalteten Systemanimationen meldet JEDER
     Browser "prefers-reduced-motion: reduce" -- auch wenn das nur eine
     Leistungseinstellung war und niemand Bewegung vermeiden wollte. Genau
     dieser Fall ist bei uns im Haus der Normalfall. Ein komplettes Abschalten
     waere hier ueberzogen: das Aufblitzen bewegt nichts, es aendert nur die
     Helligkeit von 1-px-Punkten um zwei Zehntel.
     Deshalb nur langsamer statt aus -- Aussehen, Dichte und Helligkeit
     bleiben gleich, jeder Blitz dauert knapp doppelt so lang. */
  var FUNKEN_RUHIG = {
    raster: FUNKEN.raster, anteil: FUNKEN.anteil, hell: FUNKEN.hell,
    streu: FUNKEN.streu, dauer: FUNKEN.dauer * 1.8
  };

  function funkeln(kasten, FUNKEN) {
    var cv = document.createElement('canvas');
    cv.className = 'gw-funken';
    cv.setAttribute('aria-hidden', 'true');
    kasten.appendChild(cv);

    var ctx = cv.getContext('2d');
    if (!ctx) { cv.remove(); return; }

    var dpr = 1, breite = 0, hoehe = 0, spalten = 1, zeilen = 1;
    var funken = [], belegt = {}, zeit = 0, letzt = null, laeuft = false, raf = 0;

    function messen() {
      var r = kasten.getBoundingClientRect();
      if (!r.width || !r.height) return;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      breite = r.width; hoehe = r.height;
      cv.width = Math.round(breite * dpr);
      cv.height = Math.round(hoehe * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      spalten = Math.max(1, Math.floor(breite / FUNKEN.raster));
      zeilen = Math.max(1, Math.floor(hoehe / FUNKEN.raster));
      /* Nach dem Umbau stimmen die alten Rasterstellen nicht mehr. */
      funken = []; belegt = {};
    }

    function ziel() {
      return Math.max(1, Math.round(spalten * zeilen * FUNKEN.anteil / 100));
    }

    function neuerFunke(versetzt) {
      for (var v = 0; v < 12; v++) {
        var sx = Math.floor(Math.random() * spalten);
        var sy = Math.floor(Math.random() * zeilen);
        var s = sx + ':' + sy;
        if (belegt[s]) continue;
        belegt[s] = true;
        /* Dauer streut um plus/minus 35 %, sonst atmen alle im Gleichtakt. */
        var d = FUNKEN.dauer * (0.65 + Math.random() * 0.7);
        funken.push({
          sx: sx, sy: sy, s: s, dauer: d,
          /* Beim Auffuellen mehrerer auf einmal bekommt jeder einen zufaelligen
             Startpunkt in seinem Leben -- sonst gingen alle gemeinsam auf. */
          start: versetzt ? zeit - Math.random() * d : zeit
        });
        return;
      }
    }

    function zeichnen() {
      ctx.clearRect(0, 0, breite, hoehe);
      var halb = FUNKEN.raster / 2;
      for (var i = funken.length - 1; i >= 0; i--) {
        var f = funken[i];
        var u = (zeit - f.start) / f.dauer;
        if (u >= 1) { delete belegt[f.s]; funken.splice(i, 1); continue; }
        /* Aufgehen und Verloeschen als halbe Sinuswelle: weich an beiden Enden. */
        var a = Math.sin(Math.PI * u) * FUNKEN.hell;
        if (a <= 0.004) continue;
        var x = f.sx * FUNKEN.raster + halb;
        var y = f.sy * FUNKEN.raster + halb;
        if (FUNKEN.streu > 0.05) {
          var r = 1.05 + FUNKEN.streu;
          var g = ctx.createRadialGradient(x, y, 1.05, x, y, r);
          g.addColorStop(0, 'rgba(255,255,255,' + (a * 0.5) + ')');
          g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.fillStyle = g;
          ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832); ctx.fill();
        }
        ctx.fillStyle = 'rgba(255,255,255,' + a + ')';
        ctx.beginPath(); ctx.arc(x, y, 1.05, 0, 6.2832); ctx.fill();
      }
    }

    function takt(t) {
      if (!laeuft) return;
      if (letzt === null) letzt = t;
      zeit += Math.min(0.25, (t - letzt) / 1000);
      letzt = t;
      var z = ziel();
      var viele = z - funken.length > 2;
      while (funken.length < z) neuerFunke(viele);
      while (funken.length > z) { var w = funken.shift(); delete belegt[w.s]; }
      zeichnen();
      raf = requestAnimationFrame(takt);
    }

    function start() {
      if (laeuft || document.hidden) return;
      laeuft = true; letzt = null;
      raf = requestAnimationFrame(takt);
    }
    function stopp() {
      laeuft = false; letzt = null;
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }

    messen();
    if (window.ResizeObserver) new ResizeObserver(messen).observe(kasten);
    else window.addEventListener('resize', messen);

    /* Nur laufen, solange der Kasten sichtbar ist und der Tab vorn liegt. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) start(); else stopp();
      }, { threshold: 0 }).observe(kasten);
    } else {
      start();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopp();
      else if (kasten.getBoundingClientRect().bottom > 0) start();
    });
  }

  function initFunkeln(scope) {
    if (!window.requestAnimationFrame) return;
    /* data-gw-motion am <html> uebersteuert die Systemeinstellung:
       "force" = volle Werte, "aus" = gar keine Leinwand. */
    var wahl = document.documentElement.dataset.gwMotion;
    if (wahl === 'aus') return;
    var grund = (reduceMotion && wahl !== 'force') ? FUNKEN_RUHIG : FUNKEN;
    var wurzel = scope || document;
    GRUPPEN.forEach(function (gruppe) {
      var werte = {
        raster: grund.raster, hell: grund.hell, streu: grund.streu,
        dauer: grund.dauer, anteil: anteil_fuer(gruppe.anteil)
      };
      [].forEach.call(wurzel.querySelectorAll(gruppe.wahl), function (kasten) {
        if (kasten.dataset.gwFunken) return;
        kasten.dataset.gwFunken = '1';
        funkeln(kasten, werte);
      });
    });
  }

  /* ---------- Boot ---------- */
  function initAll(scope) {
    initDropzones(scope);
    initForms(scope);
    initSpotlight(scope);
    initReveal(scope);
    initSticky(scope);
    initFunkeln(scope);
  }

  /* ---------- Bild-Lightbox: Vollansicht, Blättern, Download ---------- */
  var LB = (function () {
    var box, imgEl, strip, countEl, dlEl, items = [], idx = 0, lastFocus = null;

    function collect() {
      box = document.querySelector('[data-gw-lb]');
      var src = document.querySelector('[data-gw-lb-data]');
      if (!box || !src) return false;
      try { items = JSON.parse(src.textContent) || []; } catch (err) { items = []; }
      if (!items.length) return false;
      imgEl = box.querySelector('[data-gw-lb-img]');
      strip = box.querySelector('[data-gw-lb-strip]');
      countEl = box.querySelector('[data-gw-lb-count]');
      dlEl = box.querySelector('[data-gw-lb-dl]');
      if (!strip.children.length) {
        items.forEach(function (it, i) {
          var d = document.createElement('div');
          d.setAttribute('data-i', i);
          var im = document.createElement('img');
          im.src = it.dl; im.alt = it.alt || ''; im.loading = 'lazy';
          d.appendChild(im); strip.appendChild(d);
        });
      }
      return true;
    }

    function show(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      imgEl.src = it.full;
      imgEl.alt = it.alt || '';
      dlEl.href = it.full;
      dlEl.setAttribute('download', it.name || 'bild.jpg');
      countEl.textContent = (idx + 1) + ' / ' + items.length;
      Array.prototype.forEach.call(strip.children, function (c, n) {
        c.classList.toggle('gw-active', n === idx);
      });
    }

    function open(i) {
      if (!items.length && !collect()) return;
      lastFocus = document.activeElement;
      box.hidden = false;
      box.classList.add('gw-open');
      document.body.classList.add('gw-lb-lock');
      show(i || 0);
      var c = box.querySelector('[data-gw-lb-close]'); if (c) c.focus();
    }

    function close() {
      if (!box) return;
      box.classList.remove('gw-open');
      box.hidden = true;
      document.body.classList.remove('gw-lb-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Cross-Origin-<a download> wird von Browsern ignoriert → als Blob holen.
    // Das Shopify-CDN liefert "access-control-allow-origin: *", also klappt fetch.
    function download(e) {
      var it = items[idx]; if (!it) return;
      e.preventDefault();
      var a = e.currentTarget;
      var label = a.querySelector('span');
      var old = label ? label.textContent : '';
      if (label) label.textContent = 'Lädt …';
      fetch(it.full, { mode: 'cors' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
        .then(function (b) {
          var u = URL.createObjectURL(b);
          var t = document.createElement('a');
          t.href = u; t.download = it.name || 'bild.jpg';
          document.body.appendChild(t); t.click(); t.remove();
          setTimeout(function () { URL.revokeObjectURL(u); }, 1500);
          if (label) label.textContent = old;
        })
        .catch(function () {
          if (label) label.textContent = old;
          window.open(it.full, '_blank', 'noopener'); // Fallback: neues Tab
        });
    }

    function bind() {
      if (!collect() || box.dataset.gwBound) return;
      box.dataset.gwBound = '1';
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('[data-gw-lb-close]')) return close();
        if (e.target.closest('[data-gw-lb-prev]')) return show(idx - 1);
        if (e.target.closest('[data-gw-lb-next]')) return show(idx + 1);
        var s = e.target.closest('[data-i]');
        if (s) return show(parseInt(s.getAttribute('data-i'), 10) || 0);
      });
      if (dlEl) dlEl.addEventListener('click', download);
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
      var sx = null;
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 55) show(dx < 0 ? idx + 1 : idx - 1);
      }, { passive: true });
    }

    return { init: bind, open: open, close: close };
  })();
  window.GWLightbox = LB;

  // Expose so duplicate includes can re-init without re-running setup.
  window.GWTheme = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); LB.init(); });
  } else {
    initAll(document); LB.init();
  }

  // Re-init when a section is (re)rendered in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
